import { useEffect, useMemo } from 'react';
import {
  useCurrentProductId,
  useCurrentProjectId,
  useCurrentProject,
} from '@adsk/alloy-provider';
import { useDataApi } from '@adsk/alloy-helpers';
import { computeAdminAccessProducts, buildGetProjectRequest } from './utils';

/**
 * Custom Hook used to fetch all the data required by Project Settings Tab
 */
const useProjectSettings = (useGetConstructionApis) => {
  const projectId = useCurrentProjectId();
  const productId = useCurrentProductId();
  const currentProject = useCurrentProject();
  const {
    data: dataGetProject,
    setData: setDataGetProject,
    doFetch: doFetchGetProject,
  } = useDataApi();
  const {
    data: dataPatchProject,
    error: errorPatchProject,
    doFetch: doFetchPatchProject,
  } = useDataApi();
  const currentProjectProducts = currentProject?.products;

  const adminAccessProducts = useMemo(
    () => computeAdminAccessProducts(currentProjectProducts, projectId),
    [currentProjectProducts, projectId]
  );

  // Fetch Project Data when projectId changes
  useEffect(() => {
    if (projectId == null || useGetConstructionApis == null) return;

    doFetchGetProject(
      buildGetProjectRequest(projectId, useGetConstructionApis)
    );
  }, [projectId, doFetchGetProject, useGetConstructionApis]);

  return {
    adminAccessProducts,
    dataGetProject,
    setDataGetProject,
    dataPatchProject,
    doFetchPatchProject,
    errorPatchProject,
    productId,
    projectUserAccess: currentProject?.accessLevels,
  };
};

export default useProjectSettings;
